/**
 * Hook to initialize dark mode from persisted state on mount.
 */

import { useEffect } from 'react'
import { useEnergyStore } from '@/stores/useEnergyStore'

export const useDarkModeInit = () => {
  const darkMode = useEnergyStore((s) => s.darkMode)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode)
  }, [darkMode])
}
